export default "__VITE_ASSET__BZ$UKY7q__"